import request from '../adminRequest'
export const interviewQuestionApi = {
  listInterviewQuestion (params) {
    return request.get('/interviewQuestions', { params: params })
  },
  getInterviewQuestion (id) {
    return request.get('/interviewQuestions/' + id)
  },
  saveInterviewQuestion (data) {
    return request.post('/interviewQuestions', data)
  },
  updateInterviewQuestion (id, data) {
    return request.put('/interviewQuestions/' + id, data)
  },
  deleteInterviewQuestion (id) {
    return request.delete('/interviewQuestions/' + id)
  },
  publishAll (data) {
    return request.put('/interviewQuestions', data)
  },
}

export default interviewQuestionApi
